import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  modelData!: any;
  submitbtnTxt: String = 'Submit';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>
  ) {
    this.modelData = data;
    if (data?.button?.submitbtnText) {
      this.submitbtnTxt = data?.button?.submitbtnText;
    }
  }

  closeModel(responseType: string): void {
    this.dialogRef.close(responseType);
  }
}
